'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isNumber;
/**
 * Check if a value is a number
 * @ignore
 * @param {*} value
 * @return {boolean}
 */
function isNumber(value) {
  return typeof value === 'number';
}
//# sourceMappingURL=isNumber.js.map


// WEBPACK FOOTER //
// ./node_modules/luna-react/dist/utils/isNumber.js